import { createRouter, createWebHistory, RouterView } from "vue-router";
import mainLayout from "../layout/mainLayout.vue";

/**
 * 检测是否为移动设备
 * @returns {boolean} 如果是移动设备返回 true，否则返回 false
 */
const isMobileDevice = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileKeywords = [
    "android",
    "webos",
    "iphone",
    "ipad",
    "ipod",
    "blackberry",
    "windows phone",
    "mobile",
    "opera mini",
    "iemobile",
  ];

  // 检查 userAgent 是否包含移动设备关键词
  const isMobileUA = mobileKeywords.some((keyword) =>
    userAgent.includes(keyword)
  );

  // 检查屏幕宽度（小于等于768px认为是移动设备）
  const isMobileScreen = window.innerWidth <= 768;

  // 检查触摸事件支持
  const hasTouchScreen =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;

  return isMobileUA || (isMobileScreen && hasTouchScreen);
};

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      component: mainLayout,
      redirect: "/homePage",
      children: [
        {
          path: "/homePage",
          component: () => import("@/views/homePage/homePage.vue"),
        },
        {
          path: "/dataFamily",
          component: () => import("@/views/dataFamilyPage.vue"),
        },
        // {
        //   path: "/videoCenter",
        //   component: () =>
        //     import("@/views/videoCenter/videoCenter.vue"),
        // },
        {
          path: "/superComputing",
          component: () => import("@/views/superComputing/superComputing.vue"),
        },
        {
          path: "/newProductCenter",
          component: () => import("@/views/newProductCenter.vue"),
        },
        {
          path: "/dataBusiness",
          component: () => import("@/views/dataBusinessPage.vue"),
        },
        {
          path: "/dataOffice",
          component: () => import("@/views/dataOfficePage.vue"),
        },
        {
          path: "/dataSchool",
          component: () => import("@/views/dataSchoolPage.vue"),
        },
        {
          path: "/dataBuilding",
          component: () => import("@/views/dataBuildingPage.vue"),
        },
        {
          path: "/dataCommunity",
          component: () => import("@/views/dataCommunityPage.vue"),
        },
        {
          path: "/productCenter",
          component: () => import("@/views/productCenter/productCenter.vue"),
        },
        {
          path: "/productDetailPage",
          component: () =>
            import("@/views/productCenter/productDetailPage.vue"),
        },
        {
          path: "/businessCooperation",
          component: RouterView,
          children: [
            {
              path: "/businessCooperation",
              component: () => import("@/views/businessCooperationPage.vue"),
            },
            {
              path: "/businessCooperation/showRoom",
              component: () => import("@/views/showRoom/showRoom.vue"),
            },
          ],
        },
        {
          path: "/about",
          component: RouterView,
          redirect: "/about/companyIntroduce",
          children: [
            {
              path: "/about/companyIntroduce",
              component: () => import("@/views/companyIntroduce.vue"),
            },
            {
              path: "/about/showRoom",
              component: () => import("@/views/showRoom/showRoom.vue"),
            },
            {
              path: "/about/joinUs",
              component: () => import("@/views/joinUsPage.vue"),
            },
            {
              path: "/about/newList",
              component: () => import("@/views/newListPage/newListPage.vue"),
            },
            {
              path: "/about/newsDetail/:id",
              component: () => import("@/views/newsDetail/newsDetailPage.vue"),
            },
            {
              path: "/about/contactUs",
              component: () => import("@/views/contactUsPage.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "/Download",
      component: () => import("@/views/DownloadCenter/downloadPage.vue"),
    },
  ],
});

router.beforeEach(() => {
  // 检测是否为移动设备，如果是则跳转到移动端站点
  if (isMobileDevice()) {
    window.location.href = "https://kattgatt.com/m/";
    return false;
  }

  // 滚动到页面顶部
  document.querySelector("html")?.scrollTo({ top: 0 });
});

export default router;
